import './Home.css';
import { Link } from 'react-router-dom';

function FeatureCard({ number, icon, title, description, link, linkLabel }) {
    return (
        <div className="feature-card">
            <div className="feature-card-header">
                <span className="feature-number">{number}</span>
                <span className="feature-icon">{icon}</span>
            </div>
            <h3 className="feature-title">{title}</h3>
            <p className="feature-description">{description}</p>
            <Link to={link} className="feature-link">{linkLabel} →</Link>
        </div>
    );
}

function Home() {
    return (
        <main className="home-page">

            {/* ── Hero ── */}
            <section className="hero">
                <div className="hero-bg-text" aria-hidden="true">ČÍST</div>
                <div className="hero-content">
                    <span className="hero-eyebrow">Literární platforma</span>
                    <h1 className="hero-title">
                        Čtenář<span className="hero-title-accent">áky</span>
                    </h1>
                    <p className="hero-tagline">
                        Prozkoumejte katalog knih a autorů,<br />
                        otestujte literární znalosti a plánujte četbu.
                    </p>
                    <div className="hero-ctas">
                        <Link to="/knihy" className="cta-primary">Prozkoumat knihy</Link>
                        <Link to="/kvizy" className="cta-secondary">Hrát kvíz</Link>
                    </div>
                </div>
                <div className="hero-ornament" aria-hidden="true">❧</div>
            </section>

            {/* ── Features ── */}
            <section className="features-section">
                <div className="features-container">
                    <div className="section-header">
                        <span className="section-label">Co zde najdete</span>
                        <div className="section-rule" />
                    </div>
                    <div className="features-grid">
                        <FeatureCard
                            number="01"
                            icon="📚"
                            title="Knihy"
                            description="Rozsáhlý katalog čtenářských deníků s detailními informacemi o každém díle, žánru a době vzniku."
                            link="/knihy"
                            linkLabel="Procházet knihy"
                        />
                        <FeatureCard
                            number="02"
                            icon="✍"
                            title="Autoři"
                            description="Životopisy a bibliografie autorů — od klasiků české literatury po světové velikány."
                            link="/autori"
                            linkLabel="Procházet autory"
                        />
                        <FeatureCard
                            number="03"
                            icon="🧠"
                            title="Literární kvízy"
                            description="Interaktivní kvízy s výběrem odpovědí, doplňováním, spojováním pojmů, časovými osami i hledáním v textu."
                            link="/kvizy"
                            linkLabel="Hrát kvízy"
                        />
                        <FeatureCard
                            number="04"
                            icon="📋"
                            title="Seznam četby"
                            description="Sestavte osobní čtenářský plán s vlastními pravidly, nechte si navrhnout knihy a vygenerujte kvíz."
                            link="/seznam-cetby"
                            linkLabel="Můj seznam"
                        />
                    </div>
                </div>
            </section>

            {/* ── Flagship ── */}
            <section className="flagship-section">
                <div className="flagship-container">
                    <div className="flagship-card">
                        <div className="flagship-left">
                            <span className="flagship-tag">Vlajková funkce</span>
                            <h2 className="flagship-title">Váš osobní čtenářský plán</h2>
                            <p className="flagship-description">
                                Sestavte seznam četby podle vlastních pravidel — filtrujte českou nebo světovou literaturu, nastavte rozsah vydání či zaměřte se na konkrétní žánr. Nechte si navrhnout vhodné knihy, uložte seznam k účtu a pak si rovnou vygenerujte kvíz přesně z toho, co jste přečetli.
                            </p>
                            <div className="flagship-features">
                                {[
                                    'Vlastní pravidla výběru knih',
                                    'Návrhy knih odpovídající pravidlům',
                                    'Uložení seznamu k účtu',
                                    'Generování kvízu přímo ze seznamu',
                                ].map(f => (
                                    <div className="flagship-feature" key={f}>
                                        <span className="ff-dot" />
                                        <span>{f}</span>
                                    </div>
                                ))}
                            </div>
                            <Link to="/seznam-cetby" className="flagship-cta">
                                Začít sestavovat seznam →
                            </Link>
                        </div>
                        <div className="flagship-right" aria-hidden="true">
                            <div className="flagship-visual">
                                <div className="fv-label">Pravidla</div>
                                <div className="fv-line">Česká literatura <span>✓</span></div>
                                <div className="fv-line">Vydáno 1850–2000 <span>✓</span></div>
                                <div className="fv-line">Román <span>✓</span></div>
                                <div className="fv-separator" />
                                <div className="fv-label">Vybrané knihy</div>
                                <div className="fv-book">Babička — B. Němcová</div>
                                <div className="fv-book">Osudy dobrého vojáka Švejka — J. Hašek</div>
                                <div className="fv-book fv-book-dim">R.U.R. — K. Čapek</div>
                                <div className="fv-quiz-badge">⚡ Vygenerovat kvíz ze seznamu</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    );
}

export default Home;
